// extracted by mini-css-extract-plugin
export default {"quests":"styles_quests__j8bnq"};